(() => {
  // Monster Upsells currently disables pinch zoom after the theme loads.
  // Remove only restrictive viewport directives, preserving other app settings.
  const viewport = document.querySelector('meta[name="viewport"]');
  if (!viewport) return;
  const allowZoom = () => {
    const original = viewport.getAttribute('content') || '';
    const directives = original.split(',');
    const permitted = directives.filter(directive => {
      const [key, value] = directive.trim().toLowerCase().split('=');
      return !(key === 'user-scalable' && ['0', 'no'].includes(value?.trim())) &&
        !(key === 'maximum-scale' && Number(value) < 5);
    });
    if (permitted.length !== directives.length) viewport.setAttribute('content', permitted.join(','));
  };
  new MutationObserver(allowZoom).observe(viewport, { attributes: true, attributeFilter: ['content'] });
  allowZoom();
})();
